import { inject, Service } from '@angular/core';
import { NavController } from '@ionic/angular/lazy';

@Service()
export class AppNavigationService {
  private navController = inject(NavController);

  /**
   * Closes every open page and starts again on home, e.g. after switching tenant or deployment.
   * navigateRoot('/home') alone only resets the home stack: Ionic keeps the other tab stacks (history/scan-details, ...)
   * alive and reopens their last page when the tab is selected. Leaving the tabs shell destroys it with all its stacks.
   */
  async resetToHome(): Promise<void> {
    await this.navController.navigateRoot(['/switching'], { animated: false });
    await this.navController.navigateRoot(['/home'], { animated: false });
  }
}
